import { generateHash } from '../../../utils/caching/common/key-generator';

export const generateLoomAuthHash: (userId: string, cloudId: string) => number = (
	userId: string,
	cloudId: string,
) => generateHash(`loom|${userId}|${cloudId}`);
